// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_et-0";
export var fulfillmentPanelBody = "_et-1";